import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as h } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = h(
  (s, i) => /* @__PURE__ */ l.jsx(
    t,
    {
      ref: i,
      ...s,
      image: (c) => /* @__PURE__ */ l.jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 3375,
          height: 2125,
          fill: "none",
          viewBox: "0 0 3375 2125",
          ...c,
          children: [
            /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#clip0_2_406)", children: [
              /* @__PURE__ */ l.jsx(
                "path",
                {
                  fill: "#00579F",
                  d: "M1462.5 1591.29h-273.4l171-1054.181h273.38zM2453.59 562.88c-53.93-21.33-139.46-44.88-245.22-44.88-269.99 0-460.11 143.54-461.28 348.76-2.24 151.41 136.13 235.51 239.61 285.99 105.78 51.59 141.73 85.26 141.73 131.25-1.07 70.62-85.47 103.17-164.18 103.17-109.15 0-167.64-16.78-256.52-56.07l-36-16.85-38.26 236.65c64.12 29.12 182.26 54.97 304.91 56.1 286.87 0 473.63-141.32 475.85-360.01 1.09-120.01-71.97-211.96-229.49-287.1-95.63-48.234-154.19-80.758-154.19-130.111 1.12-44.865 49.53-90.819 157.48-90.819 88.88-2.251 154.18 19.049 203.65 40.364l24.73 11.194zM2816.96 1217.83c22.52-60.56 109.15-294.951 109.15-294.951-1.13 2.251 22.48-61.679 35.98-100.925l19.1 90.834s51.78 252.332 63.02 305.042zm337.48-680.721h-211.48c-65.21 0-114.76 19.049-142.89 87.465l-406.1 966.696h286.87s47.23-130.11 57.38-158.13h351.02c7.85 37.01 32.62 158.13 32.62 158.13H3375zM960.745 537.109 692.998 1255.96l-29.258-145.79c-49.501-168.226-204.747-350.998-377.992-441.878l245.247 921.878h289.111L1249.84 537.109z"
                }
              ),
              /* @__PURE__ */ l.jsx(
                "path",
                {
                  fill: "#FAA61A",
                  d: "M444.372 537.109H4.5l-4.5 21.3c343.127 87.48 570.374 298.349 663.74 551.801l-95.623-484.488c-15.743-67.328-64.123-86.392-123.745-88.613"
                }
              )
            ] }),
            /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_2_406", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h3375v2125H0z" }) }) })
          ]
        }
      )
    }
  )
);
a.displayName = "VisaIcon";
export {
  a as VisaIcon,
  a as default
};
//# sourceMappingURL=index.js.map
